/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import BundlesPanel from '../panels/bundles/BundlesPanel';
import DetailsFormula from '../panels/academicExpression/DetailsFormula';

class BundlesForm extends React.Component {
  render(){
    return(
      <div>
        <Route path={this.props.match.url} exact render={() => <BundlesPanel discursiva={this.props.match.params.discursiva} />} />
        <Route
          path={`${this.props.match.url}/formulas/:formulaId`}
          render={DetailsFormula}
        />
      </div>      
    )
  }
}

BundlesForm.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(BundlesForm);
